export const QUANTITY_MAX_THRESHOLD_PIECES = 3000;
